import { getDefaultExportFromCjs as r } from "./index.es152.js";
import { __require as e } from "./index.es239.js";
var i = e();
const a = /* @__PURE__ */ r(i);
export {
  a as default
};
//# sourceMappingURL=index.es207.js.map
